<template>
  <v-card>
    <v-card-title>
      <v-btn class="mr-4" fab dark small color="primary">
        <v-icon dark x-small>
          mdi-share-variant-outline
        </v-icon>
      </v-btn>
      <span class="text-h5">Shared Link</span
      ><span class="text-caption" v-if="status"
        ><v-chip class="ma-2" :color="status.color" text-color="white" small>
          {{ status.status }}
        </v-chip>
      </span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <template>
          <v-card min-height="100%" id="ADLCard">
            <v-toolbar dark color="primary" dense>
              <v-toolbar-title>
                <v-card-title class="body-2">
                  {{ specificAdlData.ServiceItem }} - {{ specificAdlData.Type }}
                </v-card-title>
              </v-toolbar-title>
            </v-toolbar>

            <v-container class="fill-height ma-0 pa-0 img-container" fluid>
              <div class="overlay-fade  ma-0 pa-0">
                <v-chip
                  class="ma-2 schedule-time darken-4"
                  color="blue"
                  label
                  text-color="white"
                >
                  <v-icon left>
                    mdi-clock
                  </v-icon>
                  {{ specificAdlData.ScheduledTime }}
                </v-chip>

                <img :src="specificAdlData.img" class="adl-image" />
                <div></div>
              </div>

              <p class="description ma-2 pa-2 text-body2">
                <span>
                  {{ specificAdlData.Description }}
                </span>
              </p>
            </v-container>
            <v-row dense class="ma-3">
              <v-col cols="12" sm="6">
                <v-select
                  label="Assistance"
                  outlined
                  hide-details
                  :items="assistance"
                >
                </v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  label="Exception"
                  outlined
                  height="10"
                  clearable
                  hide-details
                  :items="exception"
                ></v-select>
              </v-col>
            </v-row>

            <v-row class="ma-3">
              <v-col cols="12" sm="12" class="pa-1">
                <v-textarea
                  label="Add Notes"
                  outlined
                  auto-grow
                  hide-details
                  rows="2"
                  row-height="20"
                  class="mb-3"
                >
                </v-textarea>
              </v-col>
            </v-row>
          </v-card>
        </template>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
/*eslint-disable */
import { mapActions } from "vuex";

export default {
  data() {
    return {
      specificAdlData: [],
      assistance: [
        "Independant",
        "Minimal Assistance",
        "Moderate Assistance",
        "Total Assistance",
      ],
      exception: ["Refused", "ADL on Hold", "Absent", "Other"],
      schedule: {
        morning: "Morning",
        afternoon: "Afternoon",
        evening: "Evening",
        daily: "Daily/PRN",
      },
      status: "",
    };
  },

  methods: {
    ...mapActions({
      getLinkInfo: "shareLink/getLinkInfo",
      getSpecificService: "services/getSpecificService",
      fetchAllClientServices: "services/fetchAllClientServices",
    }),

    async getSharedLink() {
      console.log("adl");
      let code = this.$route.query.code;
      let response = await this.getLinkInfo(code);
      console.log(response);
      if (!response.success) {
        return alert("Something went wrong");
      }
      const { shareUrlInfo } = response.url;

      const specificAdlResponse = await this.getSpecificService({
        id: shareUrlInfo.id,
        clientId: shareUrlInfo.clientId,
        time: shareUrlInfo.time,
      });

      this.specificAdlData = {
        ...specificAdlResponse.data.data[0],
        img: shareUrlInfo.img,
      };

      console.log(this.specificAdlData);
    },

    addAdl() {
       //Todo submitting shared URL
    },
    getAdlInfo(services, id, clientId, time) {
      const serviceStatus = services.find(
        (item) =>
          item._id === id &&
          item.ClientID === clientId &&
          item.AdminTime === time
      );

      if (serviceStatus.Signed === true) {
        this.status = {
          status: "Complete",
          color: "success",
        };
      } else {
        this.status = {
          status: "Incomplete",
          color: "red",
        };
      }
    },
  },
};
</script>

<style scoped>
.adl-image {
  width: 100%;
  height: 250px;
  background-size: contain;
}

.overlay-fade {
  position: relative;
  box-sizing: border-box;
  height: 250px;
  width: 100%;
  overflow: hidden;
  float: left;
  margin: 10px;
}

.overlay-fade div {
  position: absolute;
  box-sizing: border-box;
  top: 0;
  background: rgb(0, 3, 28);
  background: linear-gradient(
    0deg,
    rgba(0, 3, 28, 1) 37%,
    rgba(133, 134, 146, 1) 54%,
    rgba(255, 255, 255, 1) 100%
  );
  width: 100%;
  height: 250px;
  opacity: 0.5;
  transition: all 0.2s ease-in;
}

.schedule-time {
  position: absolute;
  right: 0;
  margin-right: 10px;
  margin-top: 10px;
  z-index: 2;
}

.img-container {
  position: relative;
}

.description {
  bottom: -10px;
  position: absolute;
  color: white;
}
</style>
